import { render, staticRenderFns } from "./ProductAvailabilityDetails.vue?vue&type=template&id=2af2bfb4&"
import script from "./ProductAvailabilityDetails.vue?vue&type=script&lang=js&"
export * from "./ProductAvailabilityDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductAvailabilityDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports